export const DisplayReport = [
    {Id: 'Monthly', Name: 'Monthly'},
    {Id: 'Weekly', Name: 'Weekly'},
]
